import { render, staticRenderFns } from "./CPOTableFEP.vue?vue&type=template&id=564da09d&scoped=true&"
import script from "./CPOTableFEP.vue?vue&type=script&lang=js&"
export * from "./CPOTableFEP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564da09d",
  null
  
)

export default component.exports